import React from 'react'
import Spinner from '../Spinner/Spinner'
import { Link } from 'react-router-dom'
import Tooltip from '../Tooltip/Tooltip'

export default function OverviewTable(props) {

    const { data, title, keyName, loaded } = props

    return (
        <div className='dashboard-table-container'>
            <table className='overview-table'>
                <tr className='table-title'>
                    <th colspan="3">{title}</th>
                </tr>
                <tr className='table-subtitle'>
                    <th>{keyName}</th>
                    <th className='align-right'><div className="total-wrapper"><Tooltip tooltipId="TONs_tooltip" /> <span> TOTAL TONS </span></div></th>
                    <th className='align-right'><div className="total-wrapper"><Tooltip tooltipId="TEUs_tooltip" /><span> TOTAL TEUS  </span></div></th>
                </tr>
                <tbody>
                    {loaded ?
                        data.map(value => {
                            return (
                                <tr className='table-data-rows' key={value.id}>
                                    {
                                        keyName === 'COUNTY' ?

                                            <td className='table-data-link'><Link to={{ pathname: '/overview/county', state: { urlKey: value.urlKey, countyName: value.name } }}>{value.name}</Link></td>
                                            :
                                            <td className='table-data-link'><Link to={{ pathname: '/overview/region', state: { urlKey: value.urlKey, regionName: value.name } }}>{value.name}</Link></td>
                                    }
                                    <td className='table-data align-right'>{Math.round(Number(value.totalSTONS)).toLocaleString()}</td>
                                    <td className='table-data align-right'>{Math.round(Number(value.totalTEUs)).toLocaleString()}</td>
                                </tr>
                            )
                        }) : <Spinner />
                    }
                </tbody>
            </table>
        </div>
    )
}
